import { formatISO } from "date-fns";
import { removeMask, normalizeText, normalizeTextWithNumber } from "../../utils/removeMask";

export function dtoOnboarding({ companyId, values }) {
  const name = normalizeText(values.fullName.toUpperCase()).split(" ");
  const firstName = name.shift();
  const lastName = name.join(" ");

  const data = {
    companyId: companyId,
    fullName: normalizeText(values.fullName.toUpperCase()),
    firstName: firstName,
    lastName: lastName,
    email: String(values.personalEmail).toLowerCase(),
    taxId: removeMask(values.taxId),
    phone: `+55${values.mobile1.replace(/\D/g, "")}`,
    birthDate: formatISO(new Date(values.birthDate), {
      representation: "date",
    }),
    indication: values.indication,
    password: values.password,
    address: {
      street: normalizeTextWithNumber(values.personalStreet),
      number: normalizeTextWithNumber(values.personalNumber),
      complement: normalizeTextWithNumber(values.personalComplement),
      neighborhood: normalizeTextWithNumber(values.personalNeighborhood),
      city: normalizeText(values.personalCity),
      zipCode: removeMask(values.personalZipCode),
      state: normalizeTextWithNumber(values.personalState),
    },
    deviceToken: values.deviceToken,
    typePerson: "personal",
  };

  return data;
}

export function dtoOnboardingPJ({ companyId, values }) {
  const name = normalizeText(values.fullName.toUpperCase()).split(" ");
  const firstName = name.shift();
  const lastName = name.join(" ");

  const documents = [
    values.SOCIAL_CONTRACT,
    values.IDENTIFICATION,
    values.ENTREPRENEUR_REQUIREMENT,
    values.MINUTES_OF_ELECTION,
  ].filter((doc) => doc?.documentFile);

  try {
    const data = {
      companyId: companyId,
      fullName: normalizeText(values.tradeName.toUpperCase()),
      firstName: "",
      lastName: "",
      email: String(values.companyEmail).toLowerCase(),
      taxId: removeMask(values.taxId),
      phone: `+55${values.mobile1.replace(/\D/g, "")}`,
      password: values.password,

      birthCity: normalizeText(values.city),
      birthState: normalizeText(values.state),

      clientOrigin: "APP",
      typePerson: "company",
      street: normalizeTextWithNumber(values.street),
      number: normalizeTextWithNumber(values.number),
      complement: normalizeTextWithNumber(values.complement),
      neighborhood: normalizeTextWithNumber(values.neighborhood),
      city: normalizeText(values.city),
      zipCode: removeMask(values.zipCode),
      state: normalizeText(values.state),
      country: "BR",
      indication: values.indication,

      company: {
        companyType: values.companyType,
        legalName: normalizeText(values.legalName.toUpperCase()),
        tradeName: normalizeText(values.tradeName.toUpperCase()),
        cadastralSituation: values.cadastralSituation,
        codeActivity: values.codeActivity,
        financialEquity: Number(String(values.financialEquity)?.replace(/\D/g, "")),
        financialProfit: Number(String(values.financialProfit)?.replace(/\D/g, "")),
        constitutionDate: new Date(values.constitutionDate).toISOString(),
        fatca: values.fatca,
        persons: [
          {
            fullName: normalizeText(values.fullName.toUpperCase()),
            taxId: removeMask(values.personTaxId),
            email: String(values.personalEmail).toLowerCase(),
            phone: `+55${values.mobile1.replace(/\D/g, "")}`,
            personRoleType: String(values.personRoleType),
            gender: String(values.gender),
            maritalStatus: String(values.maritalStatus),
            birthDate: new Date(values.birthDate).toISOString(),
            pep: values.pep,
            pepRelationship: values.pepRelationship,
            street: normalizeTextWithNumber(values.personalStreet),
            number: normalizeTextWithNumber(values.personalNumber),
            complement: normalizeTextWithNumber(values.personalComplement),
            neighborhood: normalizeTextWithNumber(values.personalNeighborhood),
            city: normalizeText(values.personalCity),
            zipCode: removeMask(values.personalZipCode),
            state: normalizeText(values.personalState),
            country: "BR",
            indication: values.personalIndication,
          },
        ],
      },
      documents,
      deviceToken: values.deviceToken,
    };
    return data;
  } catch (err) {
    console.log(err);
  }
}
